module.exports = __webpack_public_path__ + "./assets/gmail_logo.png";